module.exports = __webpack_public_path__ + "img/enhancefeed_logo_white.318fb9c3.svg";